import { FETCH_ICONS_SUCCESS, IconsActionTypes, IconsState } from './types';

const initialState: IconsState = {
  icons: {},
};

export function iconsReducer(
  state: IconsState = initialState,
  action: IconsActionTypes
): IconsState {
  switch (action.type) {
    case FETCH_ICONS_SUCCESS:
      return {
        ...state,
        icons: action.icons,
      };
    default:
      return state;
  }
}
